import React from "react"
import { useTheme } from '~/contexts/ThemeContext'
import Flink from '~/components/shared/flink'
import { notBlank } from '~/utils/helpers'

import FavProd from '~/components/shared/fav-prod'

import * as styles from "~/styles/home/products.module.scss"
import * as tstyles from "~/styles/tiles/tile.module.scss"

const Products = ({ block, index }) => {
  const { customer } = useTheme()

  const checkEvent = () => {
    const ids = [2516]
    if (!ids.includes(block.id)) return
    window._conv_q = window._conv_q || []
    window._conv_q.push(["triggerConversion", "100471748"])
  }

  return (
    <div 
      className={styles.prods} 
      mok-block={index}
      g={block.gender}
      mid={block.id}
    >
      {notBlank(block.title) && (
        <h2 className={styles.title}>
          {block.title}
        </h2>
      )}
      
      <div className={styles.cont}>      
        <div className={styles.tiles}>
          {block.products.filter(x => x.pl_pima !== 99998).map( product => 
            <div key={product.shop_id} className={[styles.tile, tstyles.tile].join(' ')}>
              <meta itemProp="name" content={product.title} />
              <meta itemProp="url" content={`https://www.buckmason.com/products/${product.handle}`} />
              {(product.media && product.media.length > 0) && (
                <meta itemProp="image" content={product.media[0].image} />
              )}

              <div className={[styles.images, tstyles.images].join(' ')}>
                <Flink 
                  href={`/products/${product.handle}`} 
                  className={[tstyles.tile_link, styles.tile_link].join(' ')} 
                  aria-label={product.title} 
                  onClick={(e)=> checkEvent()}
                >
                  {product.media.map( (item, index) => 
                    <img 
                      key={item.image}
                      src={item.image} 
                      alt={item.alt} 
                      className={index === 0 ? undefined : styles.img_2} 
                      width={450} height={600} 
                      decode="async"
                    />
                  )}
                </Flink>

                {product.altcuts && (
                  <div className={tstyles.alts}>
                    {product.altcuts.opts.length} {product.altcuts.type}{product.altcuts.opts.length > 1 ? 's' : ''}
                  </div>
                )}
              </div>

              <div className={[styles.infos, tstyles.infos].join(' ')}>
                <div className={[tstyles.info].join(' ')}>
                  <Flink 
                    href={`/products/${product.handle}`} 
                    className={[tstyles.tile_link, tstyles.tile_title].join(' ')}
                    onClick={(e)=> checkEvent()}
                  >
                    {notBlank(product.pl_name) ? product.pl_name : product.title}
                  </Flink>
                  <div data-product-price className={tstyles.price}>
                    <span className={tstyles.price}>${product.price}</span>
                  </div>
                </div>
                {(customer && localStorage.getItem('ward')) && (
                  <FavProd prod_id={product.mid} tile={true} />
                )}
                <div className={[tstyles.info, tstyles.color].join(' ')}>
                  {product.color}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}



export default Products



